// src/redux/reducers/userReducer.js
const initialState = {
  users: [],
  selectedUser: null,
  totalPages: 1,
};

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case 'FETCH_USERS_SUCCESS':
      return {
        ...state,
        users: Array.isArray(action.payload)
          ? action.payload
          : action.payload.users,
        totalPages: Array.isArray(action.payload)
          ? 1
          : action.payload.totalPages || 1,
      };
    case 'FETCH_USER_SUCCESS':
      return {
        ...state,
        selectedUser: action.payload,
      };
    case 'SET_SELECTED_USER':
      return {
        ...state,
        selectedUser: action.payload,
      };
    case 'UPDATE_USER_SUCCESS':
      // Optionally update the user list here
      return state;
    case 'CLEAR_SELECTED_USER':
      return {
        ...state,
        selectedUser: null,
      };
    default:
      return state;
  }
}
